document.addEventListener("DOMContentLoaded", () => {

    /* =====================================================
    ELEMENTS
    ===================================================== */

    const searchInput = document.getElementById("fabricSearch");

    const cards = document.querySelectorAll(".fabric-card");

    const filterButtons = document.querySelectorAll(".fabric-filters button");

    /* Modal */

    const modal = document.getElementById("fabricModal");

    const modalOverlay = modal?.querySelector(".fabric-modal-overlay");

    const closeButton = modal?.querySelector(".fabric-close");

    const modalImage = document.getElementById("modalImage");

    const modalTitle = document.getElementById("modalTitle");

    const modalMaterial = document.getElementById("modalMaterial");

    const modalColor = document.getElementById("modalColor");

    const modalPerformance = document.getElementById("modalPerformance");

    const modalPet = document.getElementById("modalPet");

    const modalDescription = document.getElementById("modalDescription");

    const modalProducts = document.getElementById("modalProducts");

    const modalShopButton = document.getElementById("modalShopButton");

    const colorButtons = document.querySelectorAll(".color-dot");
    const featureButtons = document.querySelectorAll(".feature-filter button");

    let activeMaterial = "all";
    let activeColor = "";
    let activeFeature = "";

    function applyFilters() {

        const keyword = searchInput.value.toLowerCase();

        cards.forEach(card => {

            const matchesSearch =
                !keyword ||
                card.dataset.search.includes(keyword);

            const matchesMaterial =
                activeMaterial === "all" ||
                card.dataset.material === activeMaterial;

            const matchesColor =
                !activeColor ||
                card.dataset.color === activeColor;

            let matchesFeature = true;

            if (activeFeature === "performance") {

                matchesFeature =
                    card.dataset.performance === "true";

            }

            if (activeFeature === "pet") {

                matchesFeature =
                    card.dataset.pet === "true";

            }

            card.style.display =
                matchesSearch &&
                matchesMaterial &&
                matchesColor &&
                matchesFeature
                    ? ""
                    : "none";

        });

        updateResults();

    }

    /* =====================================================
       MATERIAL FILTER
    ===================================================== */

    filterButtons.forEach(button => {

        button.addEventListener("click", function () {

            filterButtons.forEach(btn =>
                btn.classList.remove("active")
            );

            this.classList.add("active");

            activeMaterial = this.dataset.filter;

            applyFilters();

        });

    });

    colorButtons.forEach(button => {

        button.addEventListener("click", function () {

            if (this.classList.contains("active")) {

                this.classList.remove("active");

                activeColor = "";

            } else {

                colorButtons.forEach(btn =>
                    btn.classList.remove("active")
                );

                this.classList.add("active");

                activeColor = this.dataset.color;

            }

            applyFilters();

        });

    });

    featureButtons.forEach(button => {

        button.addEventListener("click", function () {

            if (this.classList.contains("active")) {

                this.classList.remove("active");

                activeFeature = "";

            } else {

                featureButtons.forEach(btn =>
                    btn.classList.remove("active")
                );

                this.classList.add("active");

                activeFeature = this.dataset.feature;

            }

            applyFilters();

        });

    });

    

    /* =====================================================
    OPEN REUSABLE MODAL
    ===================================================== */

    document.querySelectorAll(".fabric-card").forEach(card => {

        card.addEventListener("click", function () {

            if (!modal) return;

            modal.classList.add("active");

            document.body.classList.add("fabric-modal-open");

            /* -------------------------
            BASIC DETAILS
            ------------------------- */

            modalTitle.textContent = this.dataset.name || "";

            modalImage.src = this.dataset.image || "";

            modalImage.alt = this.dataset.name || "";

            modalMaterial.textContent = this.dataset.material || "";

            modalColor.textContent = this.dataset.color || "";

            modalDescription.innerHTML = this.dataset.description || "";

            /* -------------------------
            WHATSAPP BUTTON
            ------------------------- */

            const fabricName = this.dataset.name || "";

            const whatsappNumber = "918657503461"; // Replace with your WhatsApp number

            const message = `Hi, I'm interested in the "${fabricName}" fabric. Please share more details.`;

            modalShopButton.href =
                `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

            /* -------------------------
            BADGES
            ------------------------- */

            modalPerformance.style.display =
                this.dataset.performance === "true"
                    ? "inline-flex"
                    : "none";

            modalPet.style.display =
                this.dataset.pet === "true"
                    ? "inline-flex"
                    : "none";

            /* -------------------------
            RELATED PRODUCTS
            ------------------------- */

            modalProducts.innerHTML = "";

            let products = [];

            try {

                products = JSON.parse(this.dataset.products || "[]");

            } catch (e) {

                products = [];

            }

            if (products.length) {

                products.forEach(product => {

                    modalProducts.innerHTML += `

                        <div class="fabric-product-card">

                            <a href="${product.url}">

                                <img
                                    src="${product.image}"
                                    alt="${product.title}">

                                <h4>${product.title}</h4>

                                <span>${product.price}</span>

                            </a>

                        </div>

                    `;

                });

            } else {

                modalProducts.innerHTML = `
                    <p>No products available for this fabric.</p>
                `;

            }

        });

    });

    /* =====================================================
    CLOSE MODAL
    ===================================================== */

    function closeFabricModal() {

        if (!modal) return;

        modal.classList.remove("active");

        document.body.classList.remove("fabric-modal-open");

    }

    closeButton?.addEventListener("click", closeFabricModal);

    modalOverlay?.addEventListener("click", closeFabricModal);


    /* =====================================================
       ESC KEY
    ===================================================== */

    document.addEventListener("keydown", (event) => {

        if (event.key === "Escape") {

            closeFabricModal();

        }

    });


    /* =====================================================
       CLICK OUTSIDE MODAL
    ===================================================== */

    modal?.addEventListener("click", function (event) {

        if (event.target === modal) {

            closeFabricModal();

        }

    });


    /* =====================================================
       IMAGE FALLBACK
    ===================================================== */

    modalImage?.addEventListener("error", function () {

        this.src = "https://via.placeholder.com/900x900?text=No+Image";

    });

    /* =====================================================
    TABS
    ===================================================== */

    document.querySelectorAll(".tab-btn").forEach(button => {

        button.addEventListener("click", function () {

            document.querySelectorAll(".tab-btn").forEach(btn => {

                btn.classList.remove("active");

            });

            document.querySelectorAll(".tab-panel").forEach(panel => {

                panel.classList.remove("active");

            });

            this.classList.add("active");

            document
                .getElementById("tab-" + this.dataset.tab)
                .classList.add("active");

        });

    });


    /* =====================================================
       NO SEARCH RESULTS
    ===================================================== */

    const grid = document.querySelector(".fabric-grid");

    let noResults = document.createElement("div");

    noResults.className = "fabric-empty";

    noResults.style.display = "none";

    noResults.innerHTML = `

        <h3>No Fabrics Found</h3>

        <p>Try searching with a different keyword.</p>

    `;

    if (grid) {

        grid.appendChild(noResults);

    }

    function updateResults() {

        let visible = 0;

        cards.forEach(card => {

            if (card.style.display !== "none") {

                visible++;

            }

        });

        if (visible === 0) {

            noResults.style.display = "block";

        } else {

            noResults.style.display = "none";

        }

    }

    if (searchInput) {

        searchInput.addEventListener("keyup", updateResults);

    }

    filterButtons.forEach(button => {

        button.addEventListener("click", updateResults);

    });


    /* =====================================================
       URL HASH SUPPORT
    ===================================================== */

    if (window.location.hash) {

        const hash = window.location.hash.replace("#", "").toLowerCase();

        document.querySelectorAll(".fabric-card").forEach(button => {

            if ((button.dataset.name || "").toLowerCase().replace(/\s+/g, "-") === hash) {

                button.click();

            }

        });

    }


    /* =====================================================
       CLOSE JAVASCRIPT
    ===================================================== */

});

document.addEventListener("DOMContentLoaded", function () {

  const library = document.querySelector(".fabric-library");

  if (!library) return;


  const results = library.querySelector(".fabric-library-results");

  const materialButtons = library.querySelectorAll(
    ".fabric-filters button"
  );

  const searchInput = library.querySelector("#fabricSearch");

  const allSections = library.querySelectorAll(
    ".fabric-material-section"
  );


  let activeMaterial = "all";


  /* =========================================
     MATERIAL FILTER
  ========================================= */

  materialButtons.forEach(function (button) {

    button.addEventListener("click", function () {

      const filter = button.dataset.filter;

      activeMaterial = filter;


      materialButtons.forEach(function (btn) {
        btn.classList.remove("active");
      });

      button.classList.add("active");


      if (filter === "all") {

        results.classList.remove("material-filtered");

        allSections.forEach(function (section) {
          section.classList.remove("is-hidden");
        });

      } else {

        results.classList.add("material-filtered");

        filterCards();

      }

    });

  });


  /* =========================================
     SEARCH
  ========================================= */

  if (searchInput) {

    searchInput.addEventListener("input", function () {

      filterCards();

    });

  }


  /* =========================================
     FILTER CARDS
  ========================================= */

  function filterCards() {

    const searchValue = searchInput
      ? searchInput.value.toLowerCase().trim()
      : "";


    const cards = library.querySelectorAll(
      ".fabric-filtered-view .fabric-card"
    );


    cards.forEach(function (card) {

      const name = (
        card.dataset.name || ""
      ).toLowerCase();


      const searchText = (
        card.dataset.search || ""
      ).toLowerCase();


      const material = (
        card.dataset.material || ""
      ).toLowerCase();


      const matchesMaterial =
        activeMaterial === "all" ||
        material === activeMaterial;


      const matchesSearch =
        !searchValue ||
        name.includes(searchValue) ||
        searchText.includes(searchValue);


      if (
        matchesMaterial &&
        matchesSearch
      ) {

        card.style.display = "";

      } else {

        card.style.display = "none";

      }

    });

  }

});

document.addEventListener("DOMContentLoaded", function () {

  const library = document.querySelector(".fabric-library");

  if (!library) return;


  const results = library.querySelector(
    ".fabric-library-results"
  );


  const materialButtons = library.querySelectorAll(
    ".fabric-filters button"
  );


  const searchInput = library.querySelector(
    "#fabricSearch"
  );


  const sections = library.querySelectorAll(
    ".fabric-material-section"
  );


  let activeMaterial = "all";


  /* =========================================
     ACCORDION
  ========================================= */

  sections.forEach(function (section, index) {

    const button = section.querySelector(
      ".fabric-material-accordion"
    );


    if (!button) return;


    button.addEventListener("click", function () {

      const isOpen =
        button.getAttribute("aria-expanded") === "true";


      if (isOpen) {

        button.setAttribute(
          "aria-expanded",
          "false"
        );

        section.classList.add(
          "is-collapsed"
        );

      } else {

        button.setAttribute(
          "aria-expanded",
          "true"
        );

        section.classList.remove(
          "is-collapsed"
        );

      }

    });

  });


  /* =========================================
     MATERIAL FILTER
  ========================================= */

  materialButtons.forEach(function (button) {

    button.addEventListener("click", function () {

      const filter =
        button.dataset.filter;


      activeMaterial = filter;


      materialButtons.forEach(function (btn) {

        btn.classList.remove("active");

      });


      button.classList.add("active");


      /* ALL */

      if (filter === "all") {

        results.classList.remove(
          "material-filtered"
        );

        sections.forEach(function (section) {

          section.classList.remove(
            "is-hidden"
          );

        });

        return;

      }


      /* SPECIFIC MATERIAL */

      results.classList.add(
        "material-filtered"
      );


      filterCards();

    });

  });


  /* =========================================
     SEARCH
  ========================================= */

  if (searchInput) {

    searchInput.addEventListener(
      "input",
      function () {

        filterCards();

      }
    );

  }


  /* =========================================
     FILTER CARDS
  ========================================= */

  function filterCards() {

    const searchValue =
      searchInput
        ? searchInput.value
            .toLowerCase()
            .trim()
        : "";


    const cards =
      library.querySelectorAll(
        ".fabric-filtered-view .fabric-card"
      );


    cards.forEach(function (card) {

      const name =
        (
          card.dataset.name || ""
        ).toLowerCase();


      const searchText =
        (
          card.dataset.search || ""
        ).toLowerCase();


      const material =
        (
          card.dataset.material || ""
        ).toLowerCase();


      const matchesMaterial =
        activeMaterial === "all" ||
        material === activeMaterial;


      const matchesSearch =
        !searchValue ||
        name.includes(searchValue) ||
        searchText.includes(searchValue);


      if (
        matchesMaterial &&
        matchesSearch
      ) {

        card.style.display = "";

      } else {

        card.style.display = "none";

      }

    });

  }


});